import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { Observable } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { AppConfig } from '../config/app-config';
import { FileSection, FileType, FileData } from './../models/fileData';

@Injectable({
  providedIn: 'root'
})
export class InvestorsService {

  constructor(private http: HttpClient, private appConfig: AppConfig) {
    
  }

  public getData(): Observable<any> {

    //return this.getDummyData();

    let url = this.appConfig.apiUrl + '/Investors/List/1';

    const reqHeaders = this.buildHeaders();

    return this.http.get(url, { headers: reqHeaders }).pipe(
      retry(1),
      catchError(this.errorHandler)
    );
  }

  getDummyData() {
    return [
      {
        "id": 1,
        "investor": "Afrox",
        "sector": "Chemicals (NMBLP)",
        "investmentValue": "R264 000 000",
        "country": "South Africa",
        "website": "http://www.afrox.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "afrox.jpg"
      },
      {
        "id": 2,
        "investor": "Air Products SA",
        "sector": "Chemicals",
        "investmentValue": "R300 000 000 ",
        "country": "South Africa ",
        "website": "http://www.airproductsafrica.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "kisspng-logo-air-products-chemicals-brand-business-2018-fore-the-kids-5b63f5657938a6.2670580915332775414966.jpg"
      },
      {
        "id": 3,
        "investor": "APM Terminals (AP Moller South Africa)",
        "sector": "Logistics",
        "investmentValue": "R50 000 000",
        "country": "Denmark",
        "website": "http://www.apmterminals.com",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "652680.png"
      },
      {
        "id": 4,
        "investor": "BAIC",
        "sector": "Automotive",
        "investmentValue": "",
        "country": "China",
        "website": "https://www.baic.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "143-1439151_aston-martin-logo-vector-baic.png"
      },
      {
        "id": 5,
        "investor": "Benteler",
        "sector": "Automotive (NMBLP)",
        "investmentValue": "R178 000 000",
        "country": "Germany",
        "website": "http://www.benteler.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "1280px-Benteler_logo.svg.png"
      },
      {
        "id": 6,
        "investor": "Bosun Bricks (Coega Concrete Product Pty Ltd)",
        "sector": "Construction",
        "investmentValue": "R50 000 000",
        "country": "Germany and South Africa",
        "website": "http://www.bosun.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Bosun-Brick-Logo-Final.png"
      },
      {
        "id": 7,
        "investor": "Coega Steels (Agni Steels)",
        "sector": "Metals",
        "investmentValue": "R150 000 000",
        "country": "India",
        "website": "http://www.agnisa.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "iaoTsIJY_400x400.jpg"
      },
      {
        "id": 8,
        "investor": "Cerebos",
        "sector": "Chemicals",
        "investmentValue": "R60 000 000",
        "country": "South Africa",
        "website": "http://www.cerebos.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Cerebos_logo.png"
      },
      {
        "id": 9,
        "investor": "CRT/ZacPak",
        "sector": "Logistics",
        "investmentValue": "R10 000 000",
        "country": "South Africa",
        "website": "http://www.zacpak.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Zacpak.png"
      },
      {
        "id": 10,
        "investor": "Coega Dairy",
        "sector": "Agro-processing",
        "investmentValue": "R150 000 000",
        "country": "South Africa",
        "website": "http://www.coegadairy.com",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "COEGA-logo.jpg"
      },
      {
        "id": 11,
        "investor": "Corro Master Light",
        "sector": "Manufacturing",
        "investmentValue": "R90 000 000",
        "country": "South Africa",
        "website": "http://corromaster.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "corromaster.jpg"
      },
      {
        "id": 12,
        "investor": "CEMZA",
        "sector": "Construction Material",
        "investmentValue": "",
        "country": "",
        "website": "https://cemza.co/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "cemza-logo-white.jpg"
      },
      {
        "id": 13,
        "investor": "DCD Wind Towers",
        "sector": "Renewable Energy",
        "investmentValue": "R178 000 000",
        "country": "South Africa",
        "website": "http://www.dcd.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "dcd.png"
      },
      {
        "id": 14,
        "investor": "Dedisa Peaking Power Plant",
        "sector": "Energy",
        "investmentValue": "R3 500 000 000",
        "country": "France",
        "website": "http://www.nersa.org.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "DEDISA.png"
      },
      {
        "id": 15,
        "investor": "Digistics",
        "sector": "Agro-processing",
        "investmentValue": "R5 000 000",
        "country": "South Africa",
        "website": "http://www.digistics.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Digistics.png"
      },
      {
        "id": 16,
        "investor": "Discovery Health (Discovery Holdings Pty Ltd)",
        "sector": "BPO",
        "investmentValue": "R15 000 000",
        "country": "South Africa",
        "website": "http://www.discovery.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "discovery-logo.jpg"
      },
      {
        "id": 17,
        "investor": "Dynamic Commodities",
        "sector": "Agro-processing",
        "investmentValue": "R50 000 000",
        "country": "South Africa",
        "website": "http://www.dynamicfood.com",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Dynamic Commodities.jpg"
      },
      {
        "id": 18,
        "investor": "Famous Brands",
        "sector": "Logistics",
        "investmentValue": "R20 000 000",
        "country": "South Africa",
        "website": "http://www.famousbrands.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Famous-Brands.png"
      },
      {
        "id": 19,
        "investor": "Faurecia",
        "sector": "Automotive (NMBLP)",
        "investmentValue": "R120 000 000",
        "country": "France",
        "website": "http://www.faurecia.com",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "faurecia-vector-logo.png"
      },
      {
        "id": 20,
        "investor": "FAW",
        "sector": "Automotive",
        "investmentValue": "R600 000 000",
        "country": "China",
        "website": "http://www.faw.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "faw-logo.png"
      },
      {
        "id": 21,
        "investor": "Grupo Antolin",
        "sector": "Automotive (NMBLP)",
        "investmentValue": "R90 000 000",
        "country": "Spain",
        "website": "http://www.grupoantolin.com",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Groupo Antolin.png"
      },
      {
        "id": 22,
        "investor": "Hella",
        "sector": "Automotive (NMBLP)",
        "investmentValue": "R10 000 000",
        "country": "Germany",
        "website": "http://www.hella.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "HELLA.png"
      },
      {
        "id": 23,
        "investor": "Himoinsa",
        "sector": "Energy",
        "investmentValue": "R57 000 000",
        "country": "South Africa",
        "website": "https://www.himoinsa.com",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Himoin SA.jpg"
      },
      {
        "id": 24,
        "investor": "ISUZU SA",
        "sector": "Automotive",
        "investmentValue": "R15 000 000",
        "country": "Japan",
        "website": "http://www.isuzu.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "isuzulogo.png"
      },
      {
        "id": 25,
        "investor": "ITPSA",
        "sector": "Agro-processing (NMBLP)",
        "investmentValue": "R30 000 000",
        "country": "South Africa",
        "website": "http://www.itpsa.com/en/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "ITPSA-LOGO.GIF"
      },
      {
        "id": 26,
        "investor": "Kenako Concrete",
        "sector": "Construction Materials",
        "investmentValue": "R78 000 000",
        "country": "South Africa",
        "website": "",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "placeholder.jpg"
      },
      {
        "id": 27,
        "investor": "MICB (Logistics Park)",
        "sector": "Automotive",
        "investmentValue": "R120 000",
        "country": "NMBLP",
        "website": "http://www.micb.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "MICB-Logo.jpg"
      },
      {
        "id": 28,
        "investor": "MSC SA",
        "sector": "Logistics (NMBLP)",
        "investmentValue": "R50 000 000",
        "country": "South Africa",
        "website": "http://www.msc.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "MSC.png"
      },
      {
        "id": 29,
        "investor": "National Ship Chandlers",
        "sector": "Logistics",
        "investmentValue": "",
        "country": "South Africa",
        "website": "http://www.natship.net/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "National Ship Chandlers.jpg"
      },
      {
        "id": 30,
        "investor": "Ocean Legacy Marine Engineering (OLME)",
        "sector": "Manufacturing",
        "investmentValue": "",
        "country": "",
        "website": "http://olme.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "OLME_LOGO_FullSize.png"
      },
      {
        "id": 31,
        "investor": "Parmalat",
        "sector": "Logistics",
        "investmentValue": "",
        "country": "",
        "website": "",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Parmalat.png"
      },
      {
        "id": 32,
        "investor": "PE Cold Storage",
        "sector": "Logistics",
        "investmentValue": "R49 250 000",
        "country": "South Africa",
        "website": "http://www.pecoldstorage.co.za",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "PE Cold Storage logo.svg"
      },
      {
        "id": 33,
        "investor": "Q-Plas",
        "sector": "Automotive (NMBLP)",
        "investmentValue": "R49 200 000",
        "country": "South Africa",
        "website": "http://www.q-plas.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Q- Plas.png"
      },
      {
        "id": 34,
        "investor": "REHAU",
        "sector": "Automotive (NMBLP)",
        "investmentValue": "R160 000 000",
        "country": "Germany",
        "website": "http://www.rehau.com",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Rehau.png"
      },
      {
        "id": 35,
        "investor": "Sanitech",
        "sector": "Chemicals",
        "investmentValue": "R10 000 000",
        "country": "South Africa",
        "website": "https://www.sanitech.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Sanitech.jpg"
      },
      {
        "id": 36,
        "investor": "Schnellecke",
        "sector": "Automotive",
        "investmentValue": "",
        "country": "",
        "website": "https://www.schnellecke.com/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Schnellecke.png"
      },
      {
        "id": 37,
        "investor": "Vector Logistics",
        "sector": "Logistics",
        "investmentValue": "R30 000 000",
        "country": "South Africa",
        "website": "http://www.vectorlog.com/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "Vector Logistics.png"
      },
      {
        "id": 38,
        "investor": "WNS",
        "sector": "BPO",
        "investmentValue": "R33 200 000",
        "country": "India",
        "website": "http://www.wns.co.za/",
        "dateAdded": "2020-04-19T17:27:27.263",
        "addedBy": 1,
        "dateModified": "2020-04-19T17:27:27.263",
        "modifiedBy": 1,
        "status": 1,
        "image": "WNS-logo.jpg"
      }
    ];
  }


  public getImage<FileData>(linkedId: number) {

    const url = this.appConfig.apiUrl + '/File/' + FileSection.Investors + '/' + FileType.Image + '/' + linkedId;

    const reqHeaders = this.buildHeaders();

    return this.http.get<any[]>(url, { headers: reqHeaders });
  }

  

  buildHeaders() {
    return new HttpHeaders({
      "Access-Control-Allow-Origin": "*",
      "content-type": "application/json; charset=utf-8"
    });
  }

  errorHandler(error) {
    console.log('service: errorHandler called');
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log('service: error! ' + errorMessage);
    return throwError(errorMessage);
  }

}
